interface Props {
	className?: string;
	fill?: string;
	width?: string;
	height?: string;
}

export const InfoCircle: React.FC<Props> = ({
	className,
	fill,
	width,
	height,
}) => {
	return (
		<svg
			width={width || '32'}
			height={height || '32'}
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M16.0003 30.3337C8.09366 30.3337 1.66699 23.907 1.66699 16.0003C1.66699 8.09366 8.09366 1.66699 16.0003 1.66699C23.907 1.66699 30.3337 8.09366 30.3337 16.0003C30.3337 23.907 23.907 30.3337 16.0003 30.3337ZM16.0003 3.66699C9.20033 3.66699 3.66699 9.20033 3.66699 16.0003C3.66699 22.8003 9.20033 28.3337 16.0003 28.3337C22.8003 28.3337 28.3337 22.8003 28.3337 16.0003C28.3337 9.20033 22.8003 3.66699 16.0003 3.66699Z"
				fill={fill || '#2D41F5'}
			/>
			<path
				d="M16 18.3337C15.4533 18.3337 15 17.8803 15 17.3337V10.667C15 10.1203 15.4533 9.66699 16 9.66699C16.5467 9.66699 17 10.1203 17 10.667V17.3337C17 17.8803 16.5467 18.3337 16 18.3337Z"
				fill={fill || '#2D41F5'}
			/>
			<path
				d="M16.0003 22.6668C15.827 22.6668 15.6537 22.6268 15.4937 22.5602C15.3337 22.4935 15.187 22.4002 15.0537 22.2802C14.9337 22.1468 14.8403 22.0135 14.7737 21.8402C14.707 21.6802 14.667 21.5068 14.667 21.3335C14.667 21.1602 14.707 20.9868 14.7737 20.8268C14.8403 20.6668 14.9337 20.5202 15.0537 20.3868C15.187 20.2668 15.3337 20.1735 15.4937 20.1068C15.8137 19.9735 16.187 19.9735 16.507 20.1068C16.667 20.1735 16.8137 20.2668 16.947 20.3868C17.067 20.5202 17.1603 20.6668 17.227 20.8268C17.2937 20.9868 17.3337 21.1602 17.3337 21.3335C17.3337 21.5068 17.2937 21.6802 17.227 21.8402C17.1603 22.0135 17.067 22.1468 16.947 22.2802C16.8137 22.4002 16.667 22.4935 16.507 22.5602C16.347 22.6268 16.1737 22.6668 16.0003 22.6668Z"
				fill={fill || '#2D41F5'}
			/>
		</svg>
	);
};
